/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Manufacturers {
  "use strict";

  export class ManufacturersContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {    

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {

        super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

        this.baseEndpoint = appSettings.API_ENDPOINTS.manufacturer;
        this.sectionTemplatePath = "app/plugins/manufacturers/sectionViews/";
                
        this.buildCrudSecurityKeys(this.securityKeys.DATA_MANUFACTURER_TAB_MAIN);
        this.entityType = "Manufacturer";
    }

    initializeSections(): void {
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_MANUFACTURER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new MainSection(0, "SECTION_MANUFACTURER_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.manufacturer,
                "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Manufacturer, null, this.securityKeys.DATA_MANUFACTURER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            this.sections.push(new NotesSection(0, "SECTION_MANUFACTURER_NOTES", "notes.html", false, false, this.appSettings.API_ENDPOINTS.manufacturer,
                "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Manufacturer, null, this.securityKeys.DATA_MANUFACTURER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

    }

    initializeHeader(model:any): void {
        this.headerContent = model.displayName; // change later to be dynamic
        this.businessTypeDetail = model.businessTypeDetail;
    }

    postCopy(): void {
        super.postCopy();
        let model = this.castModel<Model.Manufacturer>();
        model.displayName = undefined;
        model.webSiteAddress = undefined;
        model.contactName = undefined;
        model.contactPhone = undefined;
        model.emailAddress = undefined;
        model.address = undefined;
    }
  }
}